import React, { useState, useMemo } from 'react';
import { apis, apiHolder as api, ProductTagEnum, inWindow } from 'api';
import ReadListIcons from '@web-common/components/UI/Icons/svgs/ReadListSvgs';
import { handleBackEndPaid } from '../../util';
import StatusModal from '../StatusModal';
import './index.scss';
import ProductAuthTag from '@web-common/components/UI/ProductAuthTag/ProductAuthTag';
import UpgradeMeansModal from '../UpgradeMeansModal/index';
import SuccessModal from '../UpgradeMeansModal/successModal';
import ProductVersion from '@/components/Electron/ProductVersion';
import { getIn18Text } from 'api';
const Sticky = ({ tid, content, rclData, readData, refreshData, forbid = false }) => {
    var _a, _b, _c, _d;
    const trackApi = api.api.requireLogicalApi(apis.dataTrackerApiImp);
    const [activeModal, setActiveModal] = useState(null);
    const [upGradeVisible, setUpGradeVisible] = useState(false);
    const [successVisible, setSuccessVisible] = useState(false);
    const [productVisible, setProductVisible] = useState(false);
    const wordSeparator = inWindow() && window.systemLang === 'en' ? ' ' : '';
    const onUpgradeModel = async () => {
        handleBackEndPaid({ source: 'siris_read_status' });
    };
    const onProductModal = () => {
        setProductVisible(true);
        setActiveModal(null);
    };
    const rclText = useMemo(() => {
        var _a, _b;
        if (!rclData)
            return '';
        if ((_a = rclData.data) === null || _a === void 0 ? void 0 : _a.length) {
            const sucList = [];
            const failList = [];
            rclData.data.forEach(item => {
                if (item.status === 'suc') {
                    sucList.push(item);
                }
                else if (item.status === 'fail' || (item === null || item === void 0 ? void 0 : item.rclResult) === 9) {
                    failList.push(item);
                }
            });
            return `${getIn18Text('CHEHUICHENGGONG')}${wordSeparator}${sucList.length}${wordSeparator}${getIn18Text('REN')}，${getIn18Text('CHEHUISHIBAI')}${wordSeparator}${failList.length}${wordSeparator}${getIn18Text('REN')}`;
        }
        if ((_b = content === null || content === void 0 ? void 0 : content.entry) === null || _b === void 0 ? void 0 : _b.rclStatus) {
            return getIn18Text('WUFACHAKANCHE');
        }
        return '';
    }, [rclData, (_a = content === null || content === void 0 ? void 0 : content.entry) === null || _a === void 0 ? void 0 : _a.rclStatus, wordSeparator]);
    const readText = useMemo(() => {
        var _a, _b;
        if (!readData)
            return '';
        if ((_a = readData.data) === null || _a === void 0 ? void 0 : _a.length) {
            const readList = [];
            const unreadList = [];
            const unkownList = [];
            readData.data.forEach(item => {
                if (item.status === 'read') {
                    readList.push(item);
                }
                else if (item.status === 'unread') {
                    unreadList.push(item);
                }
                else {
                    unkownList.push(item);
                }
            });
            return `${getIn18Text('YIDU')}${wordSeparator}${readList.length}${wordSeparator}${getIn18Text('REN')}，${getIn18Text('WEIDU')}${wordSeparator}${unreadList.length}${wordSeparator}${getIn18Text('REN')}，${getIn18Text('WEIZHI')}${wordSeparator}${unkownList.length}${wordSeparator}${getIn18Text('REN')}`;
        }
        if ((_b = content === null || content === void 0 ? void 0 : content.entry) === null || _b === void 0 ? void 0 : _b.readStatus) {
            return getIn18Text('WUFACHAKANYUE');
        }
        return '';
    }, [readData, (_b = content === null || content === void 0 ? void 0 : content.entry) === null || _b === void 0 ? void 0 : _b.readStatus, wordSeparator]);
    const hasRcl = !!rclText;
    const hasRead = !!readText;
    const hasAnyText = hasRcl || hasRead;
    const fallbackText = useMemo(() => {
        if (hasAnyText)
            return '';
        return getIn18Text('WUFACHAKANYOU');
    }, [hasAnyText]);
    const showRclModal = () => {
        var _a;
        if ((_a = rclData === null || rclData === void 0 ? void 0 : rclData.data) === null || _a === void 0 ? void 0 : _a.length) {
            setActiveModal('rcl');
        }
    };
    const showReadModal = () => {
        var _a;
        if ((_a = readData === null || readData === void 0 ? void 0 : readData.data) === null || _a === void 0 ? void 0 : _a.length) {
            setActiveModal('read');
            trackApi.track('pcMail_click_mailReadingState_readMailPage');
        }
    };
    const modalData = activeModal === 'rcl' ? rclData : readData;
    return (React.createElement("div", { onClick: e => e.stopPropagation() },
        React.createElement("div", { className: "m-sticky" },
            React.createElement(ProductAuthTag, { tagName: ProductTagEnum.READ_STATUS_TRACK, tipText: getIn18Text('XIANSHITIYAN'), flowTipStyle: { top: '-7px', left: 'calc(100% - 60px)', borderRadius: '0px 8px 0px 8px' }, className: "m-sticky-product" },
                React.createElement("div", { className: "u-sticky" },
                    hasRcl && (React.createElement("div", { className: "u-sticky-block", onClick: showRclModal, "data-test-id": "rcl-status-tip-panel" },
                        React.createElement("span", { className: "u-sticky-title" }, getIn18Text('CHEHUIJIEGUO')),
                        React.createElement("span", { className: "u-sticky-list" }, rclText),
                        ((_c = rclData === null || rclData === void 0 ? void 0 : rclData.data) === null || _c === void 0 ? void 0 : _c.length) ? (React.createElement("span", { className: "u-sticky-icon dark-svg-invert" },
                            React.createElement(ReadListIcons.TriangleSvg, null))) : null)),
                    hasRead && (React.createElement("div", { className: "u-sticky-block", onClick: showReadModal, "data-test-id": "read-status-tip-panel" },
                        React.createElement("span", { className: "u-sticky-title" }, getIn18Text('YUEDUZHUANGTAI')),
                        React.createElement("span", { className: "u-sticky-list" }, readText),
                        ((_d = readData === null || readData === void 0 ? void 0 : readData.data) === null || _d === void 0 ? void 0 : _d.length) ? (React.createElement("span", { className: "u-sticky-icon dark-svg-invert" },
                            React.createElement(ReadListIcons.TriangleSvg, null))) : null)),
                    !hasAnyText && fallbackText && (React.createElement("div", { className: "u-sticky-block" },
                        React.createElement("span", { className: "u-sticky-list" }, fallbackText)))))),
        activeModal ? (React.createElement(StatusModal, { readListData: modalData, onClose: () => setActiveModal(null), visible: !!activeModal, refreshData: refreshData, onUpgradeModel: onUpgradeModel, onProductModal: onProductModal, tid: tid, account: content._account, forbid: forbid })) : null,
        React.createElement(UpgradeMeansModal, { visible: upGradeVisible, onClose: showSuccess => {
                showSuccess && setSuccessVisible(true);
                setUpGradeVisible(false);
            } }),
        React.createElement(SuccessModal, { visible: successVisible, onClose: () => {
                setSuccessVisible(false);
            } }),
        React.createElement(ProductVersion, { productVisible: productVisible, onUpgradeModel: onUpgradeModel, cancelMed: () => {
                setProductVisible(false);
            } })));
};
export default Sticky;
